import api from "../api";

export const listIssues = async (edition) => {
  const response = await api.get("/epaper", { params: edition ? { edition } : {} });
  return response.data.issues || [];
};

export const uploadIssue = async ({
  edition,
  dateKey,
  files,
  type = "main",
  subscriptionRequired = true,
  onProgress
}) => {
  if (!files?.length) throw new Error("Please select at least one PDF.");
  if (!dateKey) throw new Error("Please pick an issue date.");

  const payload = new FormData();
  payload.append("edition", edition);
  payload.append("dateKey", dateKey);
  payload.append("type", type);
  payload.append("subscriptionRequired", String(subscriptionRequired));
  files.forEach((file) => payload.append("pages", file));

  await api.post("/epaper", payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (event) => {
      if (!event.total || typeof onProgress !== "function") return;
      onProgress(event.loaded / event.total);
    }
  });
};

export const deleteIssue = async ({ edition, dateKey, type = "main" }) => {
  await api.delete(`/epaper/${encodeURIComponent(edition)}/${encodeURIComponent(dateKey)}`, {
    params: { type }
  });
};

export const getIssueDetail = async ({ edition, dateKey, type = "main" }) => {
  const response = await api.get(
    `/epaper/${encodeURIComponent(edition)}/${encodeURIComponent(dateKey)}`,
    { params: { type } }
  );
  return response.data.issue;
};

export const getPagePreviewUrl = async ({ edition, dateKey, page, type = "main" }) => {
  const response = await api.get(
    `/epaper/${encodeURIComponent(edition)}/${encodeURIComponent(dateKey)}/pages/${page}/preview-url`,
    { params: { type } }
  );
  return response.data.url;
};

export const removePage = async ({ edition, dateKey, page, type = "main" }) => {
  await api.delete(
    `/epaper/${encodeURIComponent(edition)}/${encodeURIComponent(dateKey)}/pages/${page}`,
    { params: { type } }
  );
};

export const addPage = async ({ edition, dateKey, file, position, type = "main" }) => {
  if (!file) throw new Error("Please select a PDF page to add.");

  const payload = new FormData();
  payload.append("page", file);
  if (position) payload.append("position", String(position));

  await api.post(
    `/epaper/${encodeURIComponent(edition)}/${encodeURIComponent(dateKey)}/pages`,
    payload,
    { headers: { "Content-Type": "multipart/form-data" }, params: { type } }
  );
};
